import React from 'react';
import img from "./assets/background.webp";
import { 
	AppBar,
  Toolbar,
  TextField,
  Button,
  List,
  ListItem,
  Divider 
} from 'react95';

const NavBar = () => {
	const [open, setOpen] = React.useState(false);
  return (
    <AppBar style={{zIndex:1}}>
      <Toolbar style={{ justifyContent: 'space-between' }}>
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <Button
            onClick={() => setOpen(!open)}
            active={open}
            style={{ fontWeight: 'bold' }}
          >
            <img
              src={img}
              alt='react95 logo'
              style={{ height: '20px', marginRight: 4 }}
            />
            Share
          </Button>
          {open && (
            <List
              style={{
                position: 'absolute',
                left: '0',
                top: '100%'
              }}
              onClick={() => setOpen(false)}
            >
              <ListItem><a href="https://fallstreak.bandcamp.com">Bandcamp</a></ListItem>
              <ListItem><a href="https://www.instagram.com/fallstreakpgh">Instagram</a></ListItem>
              <Divider />
              <ListItem disabled>OnlyFans</ListItem>
            </List>
          )}
        </div>

        <TextField placeholder='Take me to Search...' width={150} />
      </Toolbar>
    </AppBar>
  )
}

export default NavBar;
